export const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)

export function inject(url, type, opts = {}) {
  const callback = opts.callback
  const uniqueCallback = opts.uniqueCallback
  const id = opts.id
  const async = opts.async || false
  const unique = opts.unique || false
  const exist = id && document.getElementById(id)
  const node = opts.node
  const data = opts.data
  const append = opts.append || false

  if (unique && exist) {
    if (uniqueCallback) {
      uniqueCallback()
    }

    return
  }

  if (exist) {
    document.getElementById(id).remove()
  }

  switch (type) {
    case 'js':
      const d = document
      const g = d.createElement('script')
      let s = node || d.getElementsByTagName('script')[0]
      if (append) {
        s = document.scripts[document.scripts.length - 1]
      }

      g.type = 'text/javascript'

      if (data) {
        for (const key of Object.keys(data)) {
          g.dataset[key] = data[key]
        }
      }

      g.src = url

      if (id) {
        g.id = id
      }

      if (typeof callback === 'function') {
        g.onload = callback
      }

      if (async) {
        g.async = true
        g.defer = true
      }

      s.parentNode.insertBefore(g, s)
      break
    case 'css':
      const css = document.createElement('link')
      css.rel = 'stylesheet'
      css.href = url

      if (id) {
        css.id = id
      }

      document.head.appendChild(css)
      break
  }
}
